import { render, staticRenderFns } from "./SocialMediaCheck.vue?vue&type=template&id=d71a1316"
import script from "./SocialMediaCheck.vue?vue&type=script&lang=js"
export * from "./SocialMediaCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports